import React from 'react';
import PropTypes from 'prop-types';
import { IconCaretRight, IconDropDownMo } from 'svgIcons/MotionPortalIcons';
import { iconCondition } from '../helpers';

const TreeRow = ({
    depth,
    icon,
    label,
    count,
    condition,
    isExpanded,
    onToggle,
    hasChildren,
    onClick,
    descriptionText,
    hasSelectionDot
}) => {
    const indentPx = (depth - 1) * 24;
    const canExpand = typeof hasChildren === 'boolean' ? hasChildren : typeof count === 'number' && count > 0;

    const handleRowClick = (e) => {
        if (onClick) { onClick(e); }
        if (canExpand && onToggle) { onToggle(e); }
    };

    return (
        <button
            type='button'
            className='hierarchy-row'
            style={{ paddingLeft: `${indentPx + 8}px` }}
            onClick={handleRowClick}
            aria-expanded={canExpand ? isExpanded : undefined}
        >
            <span
                className='hierarchy-row__caret'
                aria-hidden='true'
                style={{ visibility: canExpand ? 'visible' : 'hidden' }}
            >
                {isExpanded ? <IconDropDownMo /> : <IconCaretRight />}
            </span>
            {condition &&
                <span className={`hierarchy-row__condition-bar asset-condition ${iconCondition(condition)}`} />
            }
            <span className='hierarchy-row__icon'>{icon}</span>
            <div className='hierarchy-row__label-container'>
                <div>
                    <span className='hierarchy-row__label'>{label}</span>
                    {typeof count === 'number' &&
                        <span className='hierarchy-row__count'>{`(${count})`}</span>
                    }
                </div>
                {descriptionText &&
                    <span className='hierarchy-row__description'>{descriptionText}</span>
                }
            </div>
            {hasSelectionDot &&
                <span className='hierarchy-row__selection-dot' aria-hidden='true' />
            }
        </button>
    );
};

TreeRow.propTypes = {
    depth: PropTypes.number.isRequired,
    icon: PropTypes.node,
    label: PropTypes.string,
    count: PropTypes.number,
    condition: PropTypes.string,
    isExpanded: PropTypes.bool,
    onToggle: PropTypes.func,
    isLeaf: PropTypes.bool,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    hasChildren: PropTypes.bool,
    descriptionText: PropTypes.string,
    hasSelectionDot: PropTypes.bool
};

export default TreeRow;
